import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/user/setup-password"
    exact
    path="/business/user/setup-password"
    component={AsyncPage}
  />,
];
